var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.noData)?_c('apexchart',{attrs:{"type":"bar","height":_vm.height,"options":_vm.chartOptions,"series":_vm.series}}):_c('div',{staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"w-100"},[_c('span',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t(`texts.data.no-products-created`)))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }